/**
 * Le volume chargé d'un trajet et son origine, tels que le serveur les compte
 * en transit au départ du chargement (`services/trip_loaded_volume.py`):
 * lu sur le bon de chargement, sinon saisi, sinon — en dernier recours — le
 * volume affecté, marqué « estimé ».
 */
const positif = (valeur) => {
  const nombre = Number(valeur);
  return Number.isFinite(nombre) && nombre > 0 ? nombre : null;
};

export function volumeCharge(trajet) {
  const t = trajet || {};
  const reel = positif(t.fuel_quantity_real);
  if (reel !== null) {
    if (String(t.fuel_quantity_real_source || '').toUpperCase() === 'OCR') {
      const confiance = Number(t.fuel_quantity_real_confidence);
      const pourcent = Number.isFinite(confiance) && confiance > 0
        ? ` ${Math.round(confiance * 100)} %`
        : '';
      return { litres: reel, origine: 'OCR', libelle: `Lu sur le bon de chargement${pourcent}` };
    }
    return { litres: reel, origine: 'MANUAL', libelle: 'Saisi' };
  }
  const estime = positif(t.allocated_quantity) ?? positif(t.fuel_quantity_estimated);
  if (estime !== null) {
    return { litres: estime, origine: 'ESTIMATED', libelle: 'Estimé : aucun bon lu ni volume saisi' };
  }
  return { litres: null, origine: null, libelle: 'Mesuré au chargement' };
}
